<template>

  <div class="contact-field-row d-flex align-items-center py-1">
    <i
      v-if="icon"
      :class="icon"
      class="contact-field-icon text-muted text-center mr-2"></i>
    <a
      v-if="href"
      :href="href"
      class="flex-grow-1 text-truncate text-body"
      target="_blank">{{ value }}</a>
    <span
      v-else
      class="flex-grow-1 text-truncate text-body">{{ value }}</span>
    <button
      type="button"
      class="contact-field-copy btn btn-link btn-sm p-0 ml-2"
      :title="$t('Copy')"
      @click="copy">
      <i :class="copied ? 'fa-solid fa-check text-success' : 'fa-regular fa-copy'"></i>
    </button>
  </div>

</template>

<script>
import copy from 'copy-to-clipboard'

export default {
  name: 'ContactFieldRow',
  props: {
    icon: {
      type: String,
      default: null
    },
    value: {
      type: String,
      default: ''
    },
    href: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      copied: false,
      timer: null
    }
  },
  beforeDestroy () {
    clearTimeout(this.timer)
  },
  methods: {
    /*
    copy
    copies the value and briefly shows a check icon as feedback
    */
    copy () {
      copy(this.value)
      this.copied = true
      clearTimeout(this.timer)
      this.timer = setTimeout(() => { this.copied = false }, 1500)
    }
  }
}
</script>

<style scoped>
.contact-field-icon {
  width: 16px;
}

/* let the value shrink so text-truncate works inside the flex row */
.contact-field-row .text-truncate {
  min-width: 0;
}

/* the copy button only appears when the row is hovered */
.contact-field-copy {
  opacity: 0;
  transition: opacity 0.15s;
}

.contact-field-row:hover .contact-field-copy {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Messaging/contact/ContactFieldRow.vue